import { useTranslation } from 'react-i18next'

import { ProfileActionsWidget } from '../../../Widget'
import {
  EMAIL_THREAD_PROFILE_ACTION_COLLAPSE_ALL_MESSAGES,
  EMAIL_THREAD_PROFILE_ACTION_EXPAND_ALL_MESSAGES,
} from '../../Email.constants'
import {
  useEmailProfileActionsContext,
  useEmailProfileContext,
  useEmailProfileMessagesListExpandContext,
} from '../../Email.hooks'
import { EmailProfileActionsWidgetNavigation } from '../EmailProfileActionsWidgetNavigation'
import { EmailProfileActionsWidgetSkeleton } from '../EmailProfileActionsWidgetSkeleton'

import * as styles from './EmailProfileActionsWidget.module.css'

function EmailProfileActionsWidget({ getActions, isThread, ...restProps }) {
  const { t } = useTranslation()

  const { entityData, sub, widgetsData } = useEmailProfileContext()

  const { collapseAll, expandAll, isAllExpanded } =
    useEmailProfileMessagesListExpandContext()

  const { handleClickAction } = useEmailProfileActionsContext()

  const actions = getActions({ entityData, isAllExpanded, sub, t, widgetsData })

  function handleClickThreadAction({ event, value }) {
    switch (value) {
      case EMAIL_THREAD_PROFILE_ACTION_COLLAPSE_ALL_MESSAGES:
        collapseAll()
        break

      case EMAIL_THREAD_PROFILE_ACTION_EXPAND_ALL_MESSAGES:
        expandAll()
        break

      default:
        handleClickAction({ event, value })
        break
    }
  }

  return (
    <ProfileActionsWidget
      {...restProps}
      actions={actions}
      contentContainerProps={{
        Skeleton: EmailProfileActionsWidgetSkeleton,
        className: styles.actionsContent,
      }}
      onClickAction={isThread ? handleClickThreadAction : handleClickAction}
    >
      <EmailProfileActionsWidgetNavigation />
    </ProfileActionsWidget>
  )
}

export default EmailProfileActionsWidget
